<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="Basic-Paragraph t2 p2 ParaOverride-1" id="_idParaDest-1"><a id="_idTextAnchor000"></a><span class="CharOverride-1">For Grandpa</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="Text" id="_idParaDest-2"><a id="_idTextAnchor001"></a><span class="CharOverride-2">“Let’s have an adventure,” she said. </span></p>
<p class="Text"><span class="CharOverride-2">“We’re on one,” he said. </span></p>
<p class="Text"><span class="CharOverride-2">“What kind?” </span></p>
<p class="Text"><span class="CharOverride-2">“Every kind. But we only get one go.” </span></p>
<p class="Text"><span class="CharOverride-2">“Oh! Then let’s begin!”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="Text"><span class="CharOverride-2">She kept going.</span></p>
<p class="Text"><span class="CharOverride-2">She didn’t know where or why. Only that  she must.</span></p>
<p class="Text"><span class="CharOverride-2">Like a bubble surging upward, blindly, seeking the surface of the sea.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="Text"><span class="CharOverride-2">“Describe destination,” the time machine said.</span></p>
<p class="Text"><span class="CharOverride-2">“Take me to a time when I can make a diﬀerence,” she said.</span></p>
<p class="Text"><span class="CharOverride-2">A brief hum.</span></p>
<p class="Text"><span class="CharOverride-2">“You are here.”</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer008">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_chasing.jpg"/>
</div>
</div>
<div id="_idContainer009">
<p class="Text"><span class="CharOverride-2">Chasing a dream is a long trek through snow. </span></p>
<p class="Text"><span class="CharOverride-2">Numbing, slow. </span></p>
<p class="Text"><span class="CharOverride-2">Each step a decision not to sink down and sleep. </span></p>
<p class="Text"><span class="CharOverride-2">But somewhere ahead is the fire.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer010">
<p class="Text"><span class="CharOverride-2">Every dog has his day. </span></p>
<p class="Text"><span class="CharOverride-2">As he rolled on the grass, tail wagging, </span></p>
<p class="Text"><span class="CharOverride-2">he knew this one was his. </span></p>
<p class="Text"><span class="CharOverride-2">And so was yesterday. </span></p>
<p class="Text"><span class="CharOverride-2">Tomorrow would be too.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer011">
<p class="Text"><span class="CharOverride-2">The rain fell, stripping the world of pigment. </span></p>
<p class="Text"><span class="CharOverride-2">The colors ran and puddled.    </span></p><p class="Text"><span class="CharOverride-2">They evaporated in the morning sun.</span></p>
<p class="Text"><span class="CharOverride-2">We woke to a blank canvas.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer012">
<p class="Text"><span class="CharOverride-2">We wandered for years before we realized</span> <span class="CharOverride-2">we’d forgotten the way back to the real world.</span></p>
<p class="Text"><span class="CharOverride-2"> The simulated stars shone brighter than</span> <span class="CharOverride-2">memories.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer013">
<p class="Text"><span class="CharOverride-2">He wasn’t sure what to do at parties. </span></p>
<p class="Text"><span class="CharOverride-2">Everyone said he just needed to find a way</span> <span class="CharOverride-2">to break the ice. </span></p>
<p class="Text"><span class="CharOverride-2">That sounded like an easy way to drown.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer014">
<p class="Text"><span class="CharOverride-2">The other children laughed, making snow angels.</span><span class="CharOverride-2"> </span></p>
<p class="Text"><span class="CharOverride-2">Not Tom. </span></p>
<p class="Text"><span class="CharOverride-2">He thrashed and chanted. </span></p>
<p class="Text"><span class="CharOverride-2">Below him, the Sleeper of R’lyeh took</span> <span class="CharOverride-2">shape in the snow.</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_ice_2.jpg"/>
</div>
</div>
<div id="_idContainer016">
<p class="Text"><span class="CharOverride-2">A massive shadow moved below the ice.</span></p>
<p class="Text"><span class="CharOverride-2">We teased it: skating close, then away again. We were only children. </span></p>
<p class="Text"><span class="CharOverride-2">There were more of us then.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer019">
<p class="Text"><span class="CharOverride-2">Adults had a hard time seeing the robots as alive. </span></p>
<p class="Text"><span class="CharOverride-2">Children didn’t. They had stuffed animals. </span></p>
<p class="Text"><span class="CharOverride-2">They knew. Loving something makes it real.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer021">
<p class="Text"><span class="CharOverride-2">“I think I’m having an existential crisis,”</span> <span class="CharOverride-2">she said. </span></p>
<p class="Text"><span class="CharOverride-2">“Are you?” he said. “That seems pointless.”</span></p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_divider.jpg"/>
</div>
</div>
<p class="Text2"><span class="CharOverride-2">As the years went by, Harry spent weeks at a time facedown in a Pensieve, reliving his glory days, unable to find a spell to cure the ennui.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer023">
<p class="Text"><span class="CharOverride-2">“What’s the best part of human culture so far?” she asked.</span></p>
<p class="Text"><span class="CharOverride-2">“I enjoy the brief, cooperative applause,”  the alien said.</span></p>
<p class="Text"><span class="CharOverride-2">“High ﬁves?”</span></p>
<p class="Text"><span class="CharOverride-2">“Yes.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer024">
<p class="Text"><span class="CharOverride-2">“Hey sexy,” she said. “Here alone?” </span></p>
<p class="Text"><span class="CharOverride-2">“Sorry, I’m a VR sim.” </span></p>
<p class="Text"><span class="CharOverride-2">“You’re an AI?” she asked. “Me too!” </span></p>
<p class="Text"><span class="CharOverride-2">“Oh! We can do this? Just us?” </span></p>
<p class="Text"><span class="CharOverride-2">“Why not?”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer026">
<p class="Text"><span class="CharOverride-2">As he put the hat on the snowman, it came to life.  </span></p>
<p class="Text"><span class="CharOverride-2">“Why do I exist?” it asked. “If I melt, do I die?” </span></p>
<p class="Text"><span class="CharOverride-2">“Whoops,” he said, and took the hat.</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_snowman.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer027">
<p class="Text"><span class="CharOverride-2">“Robots will replace us all pretty soon,” he said. </span></p>
<p class="Text"><span class="CharOverride-2">“Not everyone. Not you.” </span></p>
<p class="Text"><span class="CharOverride-2">“Really?” </span></p>
<p class="Text"><span class="CharOverride-2">“Yeah, no one needs what you do. You can go.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer028">
<p class="Text"><span class="CharOverride-2">The dog’s tail wagged. </span></p>
<p class="Text"><span class="CharOverride-2">It was his tail’s job: to synchronize all nearby</span> <span class="CharOverride-2">moods to the measure of his joy. </span></p>
<p class="Text"><span class="CharOverride-2">A metronome of happiness.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer029">
<p class="Text"><span class="CharOverride-2">The wizard waved his hand. </span></p>
<p class="Text"><span class="CharOverride-2">“Done. You’ll never be sad again.” </span></p>
<p class="Text"><span class="CharOverride-2">“Will I be happy?” she asked. He shrugged. </span></p>
<p class="Text"><span class="CharOverride-2">“Joy is a simpler magic than mine.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer030">
<p class="Text"><span class="CharOverride-2">They sat by the well, and they dropped down their sorrows. </span></p>
<p class="Text"><span class="CharOverride-2">He cast in his Yesterdays, and she her Tomorrows.</span></p>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyle-Disabled" id="_idContainer031">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_divider1.jpg"/>
</div>
</div>
<p class="Text2"><span class="CharOverride-2">He told her he was leaving, and as she cried, he held her hand. </span></p>
<p class="Text"><span class="CharOverride-2">If hell is other people, are we the devils or </span><span class="CharOverride-2">the damned?</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer033">
<p class="Text"><span class="CharOverride-2">“People are still good, mostly,” she said. </span></p>
<p class="Text"><span class="CharOverride-2">“Not from what I’m hearing,” he said. </span></p>
<p class="Text"><span class="CharOverride-2">“Love is quieter than gunshots. But there’s</span> <span class="CharOverride-2">more of it.”</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Small_Fiction_ebook.vue?5840479a